<template>
    <div>
        <h1>key events in small and medium devices</h1>
        <input type="textbox" placeholder="Keydown" v-model="searchtext1" @keydown="keyDown()"/>
        <input type="textbox" placeholder="Keydown" v-model="searchtext1" v-on:keydown="keyDown()"/>
<br/>
<input type="textbox" placeholder="Keypress" v-model="searchtext2" @keypress="keypress()"/>
        <input type="textbox" placeholder="Keypress" v-model="searchtext2" v-on:keypress="keypress()"/>
<br/>
<input type="textbox" placeholder="Keyup" v-model="searchtext3" @keyup="keyup()"/>
        <input type="textbox" placeholder="Keyup" v-model="searchtext3" v-on:keyup="keyup()"/>
<br/>

<span v-for="(item, index) in list" :key="index">
    <span>{{item.firstName}}</span>
</span>
    </div>
</template>
<script>
import httpuserprofile from '../js/http-userprofile.js'
export default {
    data(){
        return{
            searchtext1 : '',
            searchtext2 : '',
            searchtext3 : '',
            profileId : 24,
            list : []
        }
    },
    methods : {
        keyDown : function(){
            alert("KeydownEvent Fired");
            var self = this;
            self.list = [];
            self.searchtext2 = ''
            self.searchtext3 = ''
            if(this.searchtext1.length >=2) {
                console.log("into KeydownEvent1")
                setTimeout(function() {
                    console.log("into KeydownEvent2")
                    httpuserprofile.get('/userprofile/getPeopleUnderSearchBarAsSuggestion?searchText='+self.searchtext1+'&loggedInUserProfileId='+self.profileId)
                    .then(response => {        
                        console.log("keydown response: ", response)     
                        self.list = response.data;          
                    }).catch((e) => {
                        console.log("keydown error : ", e.response)
                    })     
                }, 1000);
            }
        },
        keypress : function(){
            alert("keypress Event Fired")
            var self = this;
            self.list = [];
            self.searchtext1 = ''
            self.searchtext3 = ''
            if(this.searchtext2.length >=2) {
                console.log("into keypress1")
                setTimeout(function() {
                    console.log("into keypress2")
                    httpuserprofile.get('/userprofile/getPeopleUnderSearchBarAsSuggestion?searchText='+self.searchtext2+'&loggedInUserProfileId='+self.profileId)
                    .then(response => {        
                        console.log("keypress response: ", response)  
                        self.list = response.data;             
                    }).catch((e) => {
                        console.log("keypress error : ", e.response)
                    })     
                }, 1000);
            }
        },
        keyup : function(){
            alert("key up event fired");
            var self = this;
            self.list = [];
            self.searchtext1 = ''
            self.searchtext2 = ''
            if(this.searchtext3.length >=2) {
                console.log("into keyup1")
                setTimeout(function() {
                    console.log("into keyup2")
                    httpuserprofile.get('/userprofile/getPeopleUnderSearchBarAsSuggestion?searchText='+self.searchtext3+'&loggedInUserProfileId='+self.profileId)
                    .then(response => {        
                        console.log("keyup response: ", response)  
                        self.list = response.data;                
                    }).catch((e) => {
                        console.log("keyup error : ", e.response)
                    })     
                }, 1000);
            }
        }
    }
}
</script>